import { useCallback, useEffect, useState } from 'react';

import { getVenueLinks } from 'modules/shared-menu/api';

type UseCheckOfferingPlatformLinksArgs = {
  shownVenueIds: string[];
};

export const useCheckOfferingPlatformLinks = ({ shownVenueIds }: UseCheckOfferingPlatformLinksArgs) => {
  const [checkedVenueIds, setCheckedVenueIds] = useState<Set<string>>(new Set());
  const [idsOfVenuesConnectedToOfferingPlatform, setIdsOfVenuesConnectedToOfferingPlatform] = useState<Set<string>>(
    new Set(),
  );
  const [loading, setLoading] = useState(false);

  const checkOfferingPlatformLinksForVenues = useCallback(async (venueIds: string[]) => {
    setLoading(true);
    const offeringPlatformLinks = await getVenueLinks(venueIds);
    const idsOfVenuesLinkedToOfferingPlatform = offeringPlatformLinks.venue_links.map(link => link.venue_id);
    setIdsOfVenuesConnectedToOfferingPlatform(oldSet => new Set([...oldSet, ...idsOfVenuesLinkedToOfferingPlatform]));
    setCheckedVenueIds(oldSet => new Set([...oldSet, ...venueIds]));
    setLoading(false);
  }, []);

  useEffect(() => {
    const notCheckedVenueIds = shownVenueIds.filter(venueId => !checkedVenueIds?.has(venueId));

    if (notCheckedVenueIds.length > 0) {
      checkOfferingPlatformLinksForVenues(notCheckedVenueIds);
    }
  }, [checkOfferingPlatformLinksForVenues, checkedVenueIds, shownVenueIds]);

  return {
    idsOfVenuesConnectedToOfferingPlatform,
    loading,
  };
};
